import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, useNavigate } from "react-router-dom";

import SettingsPage from '../partials/SettingsPage';
import LoadingSpinner from '../partials/LoadingSpinner';
import PageHeader from '../partials/PageHeader';

import { Button, Text, Small, Panel, H3, H4, Dropdown, Input, Tabs, Datepicker, Textarea, Box, Select } from '@bigcommerce/big-design';
import { AddIcon, ArrowDropDownIcon, AddCircleOutlineIcon, StoreIcon } from '@bigcommerce/big-design-icons';

import { zoneCreate } from '../../redux/actions/zones';

const NewZoneForm = ({ payload, addZone, newZone }) => {
  let navigate = useNavigate();

  const [submitted, setSubmitted] = useState(false);
  const [label, setLabel] = useState(null);
  const [description, setDescription] = useState('');
  const [priority, setPriority] = useState(1);

  useEffect(() => {
    if(newZone) { navigate(-1) };
  }, [newZone]);

  const setDescriptionValue = (e) => {
    setDescription(e.target.value);
  }

  const setPriorityValue = (e) => {
    let priority = parseInt(e.target.value);
    setPriority(priority);
  }

  const submitZone = () => {
    // setSubmitted(true);
    addZone(payload, label, description, priority);
  }

  const formDescription = () => {
    return(
      <>
        <Small>Have questions or need some help? Contact us at <a href="mailto:support@athousandapps.com">support@athousandapps.com</a></Small>
      </>
    )
  }

  return(
    <>
      <PageHeader stripeBackground='#c66628' helpLink="" />
      <SettingsPage title="New Zone" description={formDescription()}>
        <Panel>
          <H3>New Zone</H3>

          <Input
            required
            label="Zone Name"
            placeholder="Zone Name"
            id="label"
            type="text"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
          />

          <Input
            required
            label="Description"
            placeholder="Description"
            id="description"
            type="text"
            value={description}
            onChange={(e) => setDescriptionValue(e)} 
          />

          <Input
            required
            label="Priority"
            placeholder="Priority"
            id="priority"
            type="number"
            min="1"
            value={priority}
            onChange={(e) => setPriorityValue(e)}
          />

        </Panel>

        <Panel>
          <Button
            iconLeft={<AddIcon />}
            disabled={ submitted }
            onClick={() => submitZone() }
            isLoading={submitted}
          >
            Save Zone
          </Button>
        </Panel>

      </SettingsPage>
    </>
  )
}

const mapStateToProps = state => ({
  newZone: state.zones.newZone,
});

const mapDispatchToProps = (dispatch) => ({
  addZone: (payload, label, description, priority) => dispatch(zoneCreate(payload, label, description, priority)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewZoneForm);